import { Tooltip } from "antd-v5";
import classNames from "classnames";
import { getVocabulary } from "components/Vocabulary";
import { isEmpty, isUndefined, noop, reduce } from "lodash";
import React from "react";
import { useHistory } from "react-router-dom";
import { formatNumber } from "utils/numberUtil";
import { RiskRatingKeys } from "utils/riskScoreUtil";
import { CellRenderers, Sorters } from "utils/tableUtils";
import { updateURLSearch } from "utils/urlUtil";

import { ACTriggerProps } from "ac-components/ACTrigger";
import {
  RiskRating,
  RiskRatingDot,
} from "ac-components/ac-risk-rating-tag/ACRiskRatingTag";

import "./ACFindingSeverityRiskRating.less";

type payloadProps = {
  filters: any;
  pagination?: { page: number };
  groupBy?: string[] | undefined;
  savedSearch?: { id: number } | undefined;
};

type dataProps = {
  name: string;
  count: number;
  severity: Record<string, number>;
  riskScore: number | null;
};

type commonFiltersProps = {
  filters: {
    environmentName: string[];
    status: string[];
  };
  ignoreMitigated: boolean;
};

interface Props {
  findingSeverity: { [key: string]: number | null };
  activeRiskRatingKeys?: string[];
  payload?: payloadProps;
  clickable?: boolean;
  redirectionFindings?: (key: string) => void;
  showTrend?: boolean;
  trendDayDiff?: number;
  popupPlacement?: ACTriggerProps["placement"];
  data?: dataProps;
  TooltipComponent?: any;
  commonFilters?: commonFiltersProps;
  className?: string;
}
export default function ACFindingSeverityRiskRating({
  findingSeverity,
  payload,
  clickable = true,
  redirectionFindings,
  /*showTrend,
  trendDayDiff,
  popupPlacement,*/
  data,
  TooltipComponent = undefined,
  commonFilters,
  className,
}: Props) {
  const sortedRiskRatingKeys = RiskRatingKeys.sort(
    Sorters.RISK_RATING("riskRating", true),
  );
  const NA = CellRenderers.VALUE_OR_NA();
  const shouldAllowClick =
    clickable && !isUndefined(findingSeverity) && findingSeverity !== NA;
  const history = useHistory();
  const total = reduce(
    sortedRiskRatingKeys,
    (acc, curr) => {
      if (findingSeverity?.[curr]) {
        return acc + findingSeverity[curr]!;
      }
      return acc;
    },
    0,
  );

  const redirectToFindings = (type: string) => {
    const {
      filters,
      pagination = { page: 0 },
      groupBy = undefined,
      savedSearch = undefined,
    } = payload || {};
    const _filters = {
      ...filters,
      riskRating: type === "total" ? sortedRiskRatingKeys : [type],
    };
    updateURLSearch(
      history,
      {
        filters: _filters,
        pagination: pagination,
        savedSearch: savedSearch,
        groupBy: groupBy,
      },
      "/findings",
    );
  };

  const onClick = (
    e: React.MouseEvent<HTMLDivElement | HTMLButtonElement, MouseEvent>,
    key: string,
  ) => {
    e.stopPropagation();
    if (!shouldAllowClick) return noop();
    redirectionFindings ? redirectionFindings(key) : redirectToFindings(key);
  };

  return findingSeverity ? (
    <div className={classNames("d-flex align-items-center", className)}>
      {sortedRiskRatingKeys.map((key, i) => {
        const content = formatNumber(findingSeverity[key] ?? 0, "short");
        return (
          <React.Fragment key={i}>
            <Tooltip
              title={
                TooltipComponent && !isEmpty(data) ? (
                  <TooltipComponent
                    commonFilters={commonFilters}
                    severity={key}
                    data={data}
                  />
                ) : (
                  `${getVocabulary(key)}: ${!findingSeverity || findingSeverity[key] === CellRenderers.VALUE_OR_NA() ? "No tool(s) configured" : formatNumber(findingSeverity?.[key] || 0, "long")}`
                )
              }
            >
              <div onClick={(e) => onClick(e, key)}>
                {
                  <div
                    className={classNames(
                      "d-flex align-items-center ac-finding-risk-rating-bar",
                      {
                        clickable: clickable,
                        // "m-r-sm": !showTrend,
                      },
                    )}
                  >
                    <RiskRatingDot
                      rating={key as RiskRating}
                      style={{ marginRight: "5px" }}
                    />
                    {content}
                  </div>
                }
              </div>
            </Tooltip>
            {/* {showTrend &&
              renderTrend(
                key,
                {},
                findingSeverity || {},
                total,
                true,
                false,
                true,
                trendDayDiff,
              )} */}
          </React.Fragment>
        );
      })}
      {
        <Tooltip title={`Total: ${formatNumber(total || 0, "long")}`}>
          <div
            onClick={(e) => onClick(e, "total")}
            className={classNames(
              "ac-finding-risk-rating-bar ac-finding-risk-rating-bar-total",
              {
                clickable: clickable,
              },
            )}
          >
            T {formatNumber(total, "short")}
          </div>
        </Tooltip>
      }
    </div>
  ) : (
    CellRenderers.VALUE_OR_NA()
  );
}
